import { useParams } from 'react-router-dom';

import { useSession } from '@/providers/SessionProvider/SessionProvider';

const useGetClientId = () => {
  const { clients } = useSession();
  const { clientId: clientIdFromParam } = useParams();

  const [firstAvailableClient] = clients;
  const clientId = clientIdFromParam ?? firstAvailableClient?.id;

  return clientId;
};

export default useGetClientId;
